import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.filter.js";

/**
 * Helper to get the MEID field name that the event type can accept
 * @param {string} eventType
 * @returns {string} meidFieldName
 */
export var getMeidFieldName = function getMeidFieldName(eventType) {
  // TODO(EXPLAT-339): Set `model_execution_ids` field type for all `product_impression` subclasses
  var meidFieldName = eventType === 'product_impression' ? 'model_execution_ids' : 'causal_model_execution_ids';
  return meidFieldName;
};

/**
 * Helper to get model execution IDs from a context
 * @param {Context} context
 * @param {Array<string> | null} otherModelExecutionIds
 * @returns {Array<string>} meidFieldNames
 */
export var getModelExecutionIds = function getModelExecutionIds(_ref) {
  var context = _ref.context,
      otherModelExecutionIds = _ref.otherModelExecutionIds;
  var combinedMeids = [].concat(_toConsumableArray(otherModelExecutionIds || []), _toConsumableArray((context === null || context === void 0 ? void 0 : context.modelExecutionIds) || [])).filter(Boolean); // Returning an empty array creates validation errors, so we return null instead

  var modelExecutionIds = combinedMeids.length ? combinedMeids : null;
  return modelExecutionIds;
};